import clsx from "clsx";

export const ProgressBar = () => (
  <div
    className={clsx(
      "fixed",
      "top-0",
      "left-0",
      "right-0",
      "z-[100]",
      "h-4",
      "bg-gradient-to-r",
      "from-pr-blue",
      "to-pr-green",
      "w-full",
      "bg-gradient-to-r",
      "bg-gradient-to-r",
    )}
    style={{
      backgroundSize: "200% 200%",
      animation: `postDiverAnimation 2s linear infinite`,
    }}
  ></div>
);

export default ProgressBar;
